import { Component } from "@angular/core";
import { AuthService } from '../../_services/auth.service';

@Component({
    selector: "forbidden",
    templateUrl: "./forbidden.component.html",
    styleUrls: ['./forbidden.component.css']
})

export class ForbiddenComponent {

    constructor(private authService: AuthService) {

        this.authService.isLoggedIn()

    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/components/forbidden/forbidden.component.ts